import _ from 'lodash'
import {create as mathCreate, all as mathAll} from 'mathjs'
const mathConfig = {}
const math = mathCreate(mathAll, mathConfig)

function cosineSimilarity(
  anchor: number[],
  embeddings: (number[] | undefined)[],
  limit?: number,
  normalize?: boolean
) {
  if (!anchor) return
  if (!(embeddings && embeddings.length > 0)) return
  if (normalize) {
    anchor = math.divide(anchor, math.norm(anchor)) as number[]
    // @ts-expect-error can include undefined
    embeddings = embeddings.map((e) => {
      if (e === undefined) return undefined
      return math.divide(e, math.norm(e))
    }) as number[]
  }
  // @ts-expect-error can include undefined
  const mat = math.transpose(math.matrix(embeddings))
  const res = math.multiply(math.matrix(anchor), mat)
  const sortRes = _.chain(res.toArray()).entries().sortBy(1).reverse().value()
  if (limit !== undefined) return _.slice(sortRes, 0, limit)
  return sortRes
}

function lerp(a: number, b: number, t: number): number {
  return (1 - t) * a + t * b
}

function simpleMovingAverage(values: number[], interval: number) {
  let index = interval - 1
  const length = values.length + 1
  const results = []
  while (index < length) {
    index = index + 1
    const intervalSlice = values.slice(index - interval, index)
    const sum = intervalSlice.reduce((prev, curr) => prev + curr, 0)
    results.push(sum / interval)
  }
  return results
}

export {
  math,
  // toSpherical,
  // toSpherical2D,
  // toCartesian,
  // toCartesian2D,
  // computeArc,
  // closestToArc,
  // closestToMultipleArcs,
  cosineSimilarity,
  lerp,
  simpleMovingAverage,
}
